// validation patterns

export type MaskRule = string | RegExp;

export const mmddyyyy: MaskRule[] = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const phone: MaskRule[] = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const ddmmyy: MaskRule[] = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/];
